import {
  dateOnlyToDatePickerValue,
  getFormattedDate,
} from '@lib/utils/dateTimeHelpers';
import { dayDateFormat, shortDateFormat } from '@lib/enums/dateTime';

const MONTH_BUCKET_REGEXP = /^\d{4}-\d{2}$/;

export default function getBucketPeriodLabel(
  bucketId: string | null | undefined,
  language?: string,
) {
  if (!bucketId) return '';
  const isMonthBucket = MONTH_BUCKET_REGEXP.test(bucketId);
  const ymd = isMonthBucket ? `${bucketId}-01` : bucketId;
  return getFormattedDate(
    dateOnlyToDatePickerValue(ymd),
    isMonthBucket ? shortDateFormat : dayDateFormat,
    language,
  );
}
